export default "__VITE_ASSET__27b72b63__"